/* oxlint-disable react/react-compiler -- Existing code is not yet compatible with React Compiler checks. */
import * as React from 'react';

import { useLiveRef } from './useLiveRef';

/**
 * Returns a stable value that is only updated when the value changes.
 * @param value The value to stabilize.
 * @param isEqual The function to compare the values.
 */
export function useStable<T>(value: T, isEqual: (a: T, b: T) => boolean): T {
    const ref = React.useRef(value);
    const isEqualRef = useLiveRef(isEqual);
    return React.useMemo(() => {
        if (!isEqualRef.current(value, ref.current)) {
            ref.current = value;
        }
        return ref.current;
    }, [value, isEqualRef]);
}
